import { getGTMConfig } from '@/data/events/handlers/gtm';
import { useSettings } from '@/data/Settings';
import { triggerGA4EcommerceEvent } from 'presentation/events/services/ga4EcommerceService';
import { buildGA4PageLoadEventPayload } from 'presentation/events/utils/ga4Utils';
import { useCallback } from 'react';

export const useTrackPageLoad = () => {
	const { settings } = useSettings();

	return useCallback(
		(params?: { sku: string; categories: string[] }) => {
			const { ga4 } = getGTMConfig(settings);

			if (!ga4) return;

			triggerGA4EcommerceEvent(buildGA4PageLoadEventPayload(params));
		},
		[settings]
	);
};
